export default "__VITE_ASSET__CJhR48ie__"